

































import { Component, Vue } from "vue-property-decorator";
import getOpenInstall from "./openInstall.js";
@Component({
  components: {},
})
export default class Home extends Vue {
  public isMbShow = false;
  public mobile = "";
  public created() {
    this.mobile =
      navigator.appVersion.indexOf("iPhone") !== -1 ? "iPhone" : "android";
    if (this.isMobile()) {
      this.isMbShow = true;
    } else {
      this.isMbShow = false;
    }
  }
  public isMobile() {
    const flag = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
    return flag;
  }
  public registerEvent(target, eventType, cb) {
    if (target.addEventListener) {
      target.addEventListener(eventType, cb);
      return {
        remove: () => {
          target.removeEventListener(eventType, cb);
        },
      };
    } else {
      target.attachEvent(eventType, cb);
      return {
        remove: () => {
          target.detachEvent(eventType, cb);
        },
      };
    }
  }
  public isDownload(uri, failCb, successCb) {
    const target = document.createElement("input");
    target.style.width = "0";
    target.style.height = "0";
    target.style.position = "fixed";
    target.style.top = "0";
    target.style.left = "0";
    document.body.appendChild(target);
    target.focus();
    const handler = this.registerEvent(target, "blur", () => {
      successCb();
      handler.remove();
      clearTimeout(timeout);
      document.body.removeChild(target);
    });
    location.href = uri;
    const timeout = setTimeout(() => {
      failCb();
      handler.remove();
      document.body.removeChild(target);
    }, 1000);
  }
  public downloadPc() {
    this.isDownload(
      "box996://web2detail/id=180",
      () => {
        window.open(
          "//static.dhsf.996box.com/box/channel_app/996box363SetupSigned@6103.exe",
          "_self"
        );
      },
      () => {
        // 已安装
      }
    );
  }
  public downloadMb() {
    if (this.mobile === "iPhone") {
      getOpenInstall(180, 17313, "d22s18");
    } else {
      const sUserAgent = navigator.userAgent.toLowerCase();
      if (sUserAgent.indexOf("baidu") > 0) {
        alert(
          "如提示'第三方页面应用未经百度审核'，请使用系统自带浏览器下载APP"
        );
      }
      window.open(
        "//static.dhsf.996box.com/box/channel_app/1709185320000_RmjpF.apk",
        "_self"
      );
    }
  }
}
